import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const companySizeService = {
    getAllSizes,
    getSize,
    updateSize,
    createSize,
    updateSizeStatus 
};

const MODULE = {
  SIZE: 'company-sizes',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllSizes(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.SIZE}`, requestOptions)
  }

  export function getSize(id) {
    return apiHelper(API_URL).get(`/${MODULE.SIZE}/${id}`)
  }

  export function updateSize(data) {

    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.SIZE}/${data.id}`, requestOptions)
  }

  export function createSize(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.SIZE}`, requestOptions)
  }

  export function updateSizeStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
  
    return apiHelper(API_URL).patch(`/${MODULE.SIZE}/${data.id}`, requestOptions)
  }